import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import BellNotifiaction from '../BellNotifiaction';
import Modal from "react-modal";

Modal.setAppElement("#root");
export default function About() {
  const [fname4, setfname4] = useState("");
  const [newFile4, setNewFile4] = useState(null);
  const [newdata4, setnewdata4] = useState([]);


const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedImage, setSelectedImage] = useState("");

const handleImageClick = (imageSrc) => {
  setSelectedImage(imageSrc);
  setIsModalOpen(true);
};

const handleCloseModal = () => {
  setIsModalOpen(false);
};

  const setData4 = (e) => {
    const { value } = e.target;
    setfname4(value);
  };
  const setimgfile = (e) => {
    setNewFile4(e.target.files[0]);
  };

  // Add image

  const adduserdata4 = async (e) => {
    
    var formData4 = new FormData();
    console.log(newFile4);
    var filename = newFile4.name;
    formData4.append("photo4", newFile4, filename);
    formData4.append("fname4", fname4);
    console.log(formData4);

    const config = {
      headers: {
        "Content-Type": " multipart/form-data",
      },
    };

    const res = await axios.post(
      "https://pratik-agro-backend.vercel.app/AddAboutbackgroundimg",
      formData4,
      config
    );

    console.log(res);
  };
  //get image

  const getUserData4 = async () => {
    const res4 = await axios.get("https://pratik-agro-backend.vercel.app/getAboutbackgroundImg", {
      headers: {
        "Content-Type": " application/json",
      },
    });
    if (res4.data.status === 401 || !res4.data) {
      console.log("error");
    } else {
      setnewdata4(res4.data.getImage.reverse());
    }
  };
  useEffect(() => {
    getUserData4();
  }, []);
 
//delete data
const deleteimage4 = async (id) => {
 
  const res3 = await fetch(`https://pratik-agro-backend.vercel.app/deletedata4/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const deleteStud = await res3.json();
  console.log(deleteStud);
  if (res3.status === 422 || !deleteStud) {
    console.log("error");
  } else {
    getUserData4();
  }

};
  return (
    <div className='content'>
    <div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
        <i>
          <h2>Background</h2>
        </i>
       <div>
     
       <BellNotifiaction />
       <Link
          type="button"
          to="/Addhomeimage"
          className="btn btn-light shadow addimage "
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Add Image
        </Link>
       </div>
        
        
      </div>
      <div className=" container text-end mt-5">
        {/* <Link  to="/Addhomeimage"className="btn btn-success "> Add Data</Link> */}
        
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog ">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                  About Background Image
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    
                      <p style={{float:'left'}}>Background Image Name:-</p>
                    
                    <input
                      type="text"
                      name="fname4"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData4}
                    />

                    <div>
                      <p style={{float:'left'}}>Add Your Image:-</p>
                    </div>
                    <input
                      type="file"
                      name="photo4"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setimgfile}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                       onClick={adduserdata4}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="outer-wrapper">
    <div class="table-wrapper">
            <table class="table  mt-5">
        <thead className="bg-dark text-white ">
          <tr>
            <th scope="col">ID</th>
            <th scope="col"> Background Image</th>
            <th scope="col"> Background Image Name</th>
            <th scope="col">Uploaded Date</th>
            <th scope="col">Action</th>
            
          </tr>
        </thead>
        <tbody>
          {newdata4.length>0 ?newdata4.map((el,id) => {
            console.log(el)
            return (
              <>
                <tr>
                  <th scope="row mt-5">{id+1}</th>
                  <td><img src={el.Backgroundimg} alt='img'  style={{'width':'70px',textAlign:"center",margin:'auto',cursor:"pointer"}}onClick={() => handleImageClick(el.Backgroundimg)}/></td>
                  <td>{el.fname4}</td>
                  <td>{el.date}</td>
                  {/* <td>
                    <NavLink to={`/Edit/${el._id}`}><i className="bi bi-pencil-square p-4 shadow"  ></i></NavLink>
                    <i class="bi bi-archive-fill p-4 shadow" onClick={()=>deleteimage(el._id)}></i>
                  </td> */}
                  <td>
                        <button type="button" class="btn btn-outline-dark "><NavLink to={`/AboutBgEdit/${el._id}`}><i className="bi bi-pencil-square "  ></i></NavLink></button>
                        <button type="button" class="btn btn-outline-dark "><i class="bi bi-archive-fill " onClick={()=>deleteimage4(el._id)}></i></button>
                  </td>
                </tr>
              </>
            );
          }):"Loading.."
          } 
        </tbody>
        <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal}>
  <img src={selectedImage} alt="img" style={{width: '100%', height: 'auto'}} className='img-fluid' />
</Modal>
      </table>
      </div>
      </div>
    </div>
    
  )
}
